import { useState } from "react";
import * as jose from "jose";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "~/providers/router";

export const useHandleTeamMemberToken = (dataTokenParam?: string) => {
  const [inviteId, setInviteId] = useState<string>();
  const [token, setToken] = useState<string | undefined>(undefined);
  const navigate = useNavigate();

  const extractDataFromToken = () => {
    try {
      if (dataTokenParam) {
        const userJWT = jose.decodeJwt(dataTokenParam);
        const invite_id = userJWT.invite_id as string | undefined;
        const exp = userJWT.exp;

        if (!invite_id || !exp) {
          throw new Error("Invalid token");
        }

        const currentTime = Math.floor(Date.now() / 1000);
        if (currentTime >= exp) {
          navigate(ROUTES.invitationExpired);
        }

        setInviteId(invite_id);
        setToken(dataTokenParam);
      } else {
        throw new Error("Invalid token");
      }
    } catch {
      navigate(ROUTES.notFound);
    }
  };

  return {
    inviteId,
    token,
    extractDataFromToken,
  };
};
